import { createWebHistory, createRouter } from 'vue-router';
import authenticatedGuard from './guards/authenticated-guard';
import enabledGuard from './guards/enabled-guard';
import initializerHook from './hooks/initializer-hook';
import titleHook from './hooks/title-hook';
import trackHook from './hooks/track-hook';

import callbackRoute from './callback-route';
import accountRoutes from './account-routes';
import userRoutes from './user-routes';
import researchRoutes from './research-routes';
import fundingRoutes from './funding-routes';
import tradelinkRoute from './tradelink-route';
import logoutRoute from './logout-route';
import loginRoute from './login-route';

const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import('@/views/root-view.vue'),
    meta: { authenticated: true, activeUser: true, title: 'Dashboard' },
  },
  {
    name: 'error',
    path: '/error',
    component: () => import('@/views/error-view.vue'),
    meta: { authenticated: false, activeUser: false, title: 'Error', enabled: true },
  },
  loginRoute,
  logoutRoute,
  tradelinkRoute,
  callbackRoute,
  ...accountRoutes,
  ...userRoutes,
  ...researchRoutes,
  ...fundingRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(enabledGuard);
router.beforeEach(authenticatedGuard);

router.beforeResolve(initializerHook);

router.afterEach(titleHook);
router.afterEach(trackHook);

router.onError((error) => {
  console.error('Router error:', error);
  router.replace({ name: 'error', query: { code: '0002' } });
});

export default router;
